module.exports = __webpack_public_path__ + "img/016_thumbnail.a65030db.jpg";